export default __webpack_public_path__ + "static/media/Balyo.45242ed7.png";